import React, { Suspense, useEffect, useState } from 'react';
import { getApi } from '../../Services/apiService';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import Modal from 'react-modal';
import DeleteModal from './deleteOffer';
import AddOfferModal from './addOffer';
import EditOfferModal from './editOffer';

export default function Offer() {
  const navigate = useNavigate();
  const [offers, setOffers] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [addOfferModal, setAddOfferModal] = useState(false);
  const [editOfferModal, setEditOfferModal] = useState(false);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const location = useLocation();
  useEffect(() => {
    fetchOffers();
  }, [search]);

  const fetchOffers = async () => {
    setLoading(true);
    setError(null);
    try {

      const endpoint = `/admin/offer?search=${search}`;
      const response = await getApi(endpoint);
      if (response.status === 200) {
        setOffers(response.data);
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const openAddModal = () => {
    setAddOfferModal(true);
  };

  const openEditModal = (offer) => {
    setSelectedOffer(offer);
    setEditOfferModal(true);
  };

  const openDeleteOfferModal = (offer) => {
    setSelectedOffer(offer.id);
    setDeleteModal(true);
  };

  return (
    <>
      {loading && <div className="loader">  <div class="spinner"></div> </div>}
      {error && <p className="error-message">{error}</p>}

      <div className={`${location.pathname.includes('offer') ? 'RightSideDiv' : ''} ${loading ? 'blurred' : ''}`}>
        <div className='car-care-tips offer'>
          <div className="header">
            <h1>Offer</h1>
            <div className="top-right">
              <div className="right-top-search">
                <input
                  type="text"
                  placeholder="Search..."
                  autoComplete="off"
                  className="search-input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
              <div className="add-new-btn">
                <button className="add-new" onClick={openAddModal}>
                  <img src={window.getPublicUrl("/assets/images/add-plus.svg")} alt="" /> Add new
                </button>
              </div>
            </div>
          </div>

         
          <div className='row'>
            {offers?.length > 0 ? (
              offers.map((offer, index) => (
                <div className="col-sm-6" key={index}>
                  <div className="card">
                    <div className="left">
                      <span>
                        <img src={offer.image} alt="Offer" />
                      </span>
                      <div className="text">
                        <h5>{offer.offer_code}</h5>
                      </div>
                    </div>
                    <div className="right">
                      <div className="top">
                        <h1>{offer.title}</h1>
                        <h4>{offer?.Category?.name}</h4>

                      </div>
                      <div className="bottom">
                        <div className="left-text">
                          <p>Expires</p>
                          <h5>{moment.utc(offer.expiry_date).format("ddd, DD MMM YYYY")}</h5>
                        </div>
                        <div className="right-button">
                          <span onClick={() => navigate(`detail/${offer.id}`)}>
                            <img src={window.getPublicUrl("/assets/images/view.svg")} alt="View" />
                          </span>
                          <button className="edit" onClick={() => openEditModal(offer)}>
                            <img src={window.getPublicUrl("/assets/images/edit.svg")} alt="Edit" />
                          </button>
                          <button className="delete" onClick={() => openDeleteOfferModal(offer)}>
                            <img src={window.getPublicUrl("/assets/images/delete.svg")} alt="Delete" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div>
                <div colSpan="6" style={{ textAlign: "center" }}>
                  <div className='alert alert-danger'>No Offer found.</div>
                </div>
              </div>
            )}

          </div>

          <Suspense fallback={<div>Loading...</div>}>
            <Modal isOpen={addOfferModal} onRequestClose={() => setAddOfferModal(false)} contentLabel="Add Modal" shouldCloseOnOverlayClick={false} ariaHideApp={false}
              overlayClassName={`modal-overlay add-venue `}
              className={'add-offer'}
              portalClassName="add-user venuue">
              <AddOfferModal setAddOfferModal={setAddOfferModal} fetchOffers={fetchOffers} />
            </Modal>
          </Suspense>

          <Suspense fallback={<div>Loading...</div>}>
            <Modal
              isOpen={editOfferModal}
              onRequestClose={() => setEditOfferModal(false)}
              contentLabel="Edit Modal"
              shouldCloseOnOverlayClick={false}
              ariaHideApp={false}
              overlayClassName="modal-overlay add-venue"
              className={'edit-offer'}
              portalClassName="add-user venuue">
              <EditOfferModal setEditOfferModal={setEditOfferModal} fetchOffers={fetchOffers} offerData={selectedOffer} />
            </Modal>
          </Suspense>

          <Suspense fallback={<div>Loading...</div>}>
            <Modal isOpen={deleteModal} onRequestClose={() => setDeleteModal(false)} contentLabel="Delete Modal" shouldCloseOnOverlayClick={false} ariaHideApp={false}
              overlayClassName={`modal-overlay add-category delete logout `}
              portalClassName="add-user deactivate">
              <DeleteModal setDeleteModal={setDeleteModal} offerDetails={selectedOffer} fetchOffers={fetchOffers} />
            </Modal>
          </Suspense>
        </div>
      </div>
    </>
  );
}
